<div class="pt-tree" ngbAccordion [closeOthers]="true">
  <ng-container *ngFor='let item of internalNodes;'>
    <div ngbAccordionItem="{{item.uuid}}" [destroyOnHide]="true">
      <div ngbAccordionHeader>
        <div class="tree-root" >
          <div class="tree-root-toggle">
            <button ngbAccordionButton></button>
          </div>

          <input class='form-check-input' type='checkbox'
                 [indeterminate]="item.indeterminate"
                 (click)="$event.stopPropagation()"
                 [ngModel]="item.checked"
                 (ngModelChange)="selectRoot(item)">
          <div class="w-100 h-100" (click)="selectRoot(item)">{{ item.uuid }}</div>

        </div>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody class="p-0">
          <ng-template>
            <div class="tree-children" *ngFor='let children of item.children' (click)="selectChildren(item, children)">
              <input class='form-check-input'
                     type='checkbox'
                     [ngModel]="children.checked">
              <p class="m-0">
                {{ children.label }}
                <pt-w-help *ngIf="children.help" [help]="children.help"></pt-w-help>
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</div>
